import {resolvePagePath} from "@/utils/path";
import {baseAppDirname} from "@/config/constants";
import ClientBreadcrumbProvider from "./breadcrumb-provider";
import {addBreadcrumb} from "../../lib/breadcrumbs";
import {renderComponent} from "@/utils/jsx";

type Props = Parameters<typeof ClientBreadcrumbProvider>[0];

export default function BreadcrumbProvider({icon, params, menu: _menu, children, ...props}: Props)
{
    // console.log("BreadcrumbProvider PRE", {icon, _menu, ...props});
    icon = renderComponent(icon, {className: "size-[1em]"});

    const menu = _menu?.map(({icon: _icon, href, ...props}) => 
    ({
        ...props,
        icon: renderComponent(_icon, {className: "size-[1em]"}),
        href: href ?? resolvePagePath(props.dirname, params, baseAppDirname)
    }));

    addBreadcrumb({icon, menu, ...props}, params);

    // console.log("BreadcrumbProvider", {icon, menu, ...props});
    
    return <ClientBreadcrumbProvider {...props} icon={icon} menu={menu} params={params} children={children} />
}
